import { useCallback, useEffect, useState } from 'react';
import { logError } from '@betty/toolkit/logging';
import { PaymentProviders } from '../state/payment/payment.types';
import PaymentService from '../services/PaymentService/PaymentService';

const usePaymentProviders = <T extends keyof PaymentProviders>(type: T) => {
  const [data, setData] = useState<PaymentProviders[T]>();

  const fetch = useCallback(async () => {
    try {
      const data = await PaymentService.getPaymentProviders();

      setData(data[type]);
    } catch (error) {
      logError('Payment providers request failure.', error);

      return [];
    }
  }, [type]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data };
};

export default usePaymentProviders;
